//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CatalogService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSkuFormats( cancelToken?: CancelToken): Promise<ListResponseOfSkuFormat> {
        let url_ = this.baseUrl + "/api/catalog/formats/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuFormats(_response);
        });
    }

    protected processGetSkuFormats(response: AxiosResponse): Promise<ListResponseOfSkuFormat> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSkuFormat.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSkuFormat>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSkuFormat>(null as any);
    }

    getLiveOnlineCourses(request: ListRequestOfCatalogFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfLiveOnlineCourseModel> {
        let url_ = this.baseUrl + "/api/catalog/live-online/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiveOnlineCourses(_response);
        });
    }

    protected processGetLiveOnlineCourses(response: AxiosResponse): Promise<ListResponseOfLiveOnlineCourseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfLiveOnlineCourseModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfLiveOnlineCourseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfLiveOnlineCourseModel>(null as any);
    }

    getHomeStudyCourses(request: ListRequestOfCatalogFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfHomeStudyCourseModel> {
        let url_ = this.baseUrl + "/api/catalog/home-study/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHomeStudyCourses(_response);
        });
    }

    protected processGetHomeStudyCourses(response: AxiosResponse): Promise<ListResponseOfHomeStudyCourseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfHomeStudyCourseModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfHomeStudyCourseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfHomeStudyCourseModel>(null as any);
    }

    getSeries(request: ListRequestOfCatalogFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfSeriesModel> {
        let url_ = this.baseUrl + "/api/catalog/series/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeries(_response);
        });
    }

    protected processGetSeries(response: AxiosResponse): Promise<ListResponseOfSeriesModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfSeriesModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfSeriesModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfSeriesModel>(null as any);
    }
}

export class CatalogFilterService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFilters(request: CatalogFiltersRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfGenericSkuFilterModel> {
        let url_ = this.baseUrl + "/api/catalog-filters/generic/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilters(_response);
        });
    }

    protected processGetFilters(response: AxiosResponse): Promise<ListResponseOfGenericSkuFilterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfGenericSkuFilterModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfGenericSkuFilterModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfGenericSkuFilterModel>(null as any);
    }

    getDaysOfWeek( cancelToken?: CancelToken): Promise<ListResponseOfGenericSkuFilterModel> {
        let url_ = this.baseUrl + "/api/catalog-filters/days-of-week";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDaysOfWeek(_response);
        });
    }

    protected processGetDaysOfWeek(response: AxiosResponse): Promise<ListResponseOfGenericSkuFilterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfGenericSkuFilterModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfGenericSkuFilterModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfGenericSkuFilterModel>(null as any);
    }

    getAttributesFilterModel(request: CatalogAttributesFilterRequest | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAttributesFilterModel> {
        let url_ = this.baseUrl + "/api/catalog-filters/attributes-filter-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttributesFilterModel(_response);
        });
    }

    protected processGetAttributesFilterModel(response: AxiosResponse): Promise<ListResponseOfAttributesFilterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAttributesFilterModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAttributesFilterModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAttributesFilterModel>(null as any);
    }
}

export class CertificatesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCompletions(request: ListRequestOfCompletionsFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfOrganizationCompletion> {
        let url_ = this.baseUrl + "/api/certificates/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletions(_response);
        });
    }

    protected processGetCompletions(response: AxiosResponse): Promise<ListResponseOfOrganizationCompletion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfOrganizationCompletion.fromJS(resultData200);
            return Promise.resolve<ListResponseOfOrganizationCompletion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfOrganizationCompletion>(null as any);
    }

    getProfessions( cancelToken?: CancelToken): Promise<ListResponseOfProfessionModel> {
        let url_ = this.baseUrl + "/api/certificates/professions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessions(_response);
        });
    }

    protected processGetProfessions(response: AxiosResponse): Promise<ListResponseOfProfessionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfProfessionModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfProfessionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfProfessionModel>(null as any);
    }

    getExportedCertificates(request: ExportCertificatesRequest | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfCreatePdfFromHtmlResponse> {
        let url_ = this.baseUrl + "/api/certificates/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportedCertificates(_response);
        });
    }

    protected processGetExportedCertificates(response: AxiosResponse): Promise<ResponseOfCreatePdfFromHtmlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfCreatePdfFromHtmlResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfCreatePdfFromHtmlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfCreatePdfFromHtmlResponse>(null as any);
    }

    getDownloadUrl(userId: string, userCertificateId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/certificates/{userId}/{userCertificateId}/download-url";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (userCertificateId === undefined || userCertificateId === null)
            throw new globalThis.Error("The parameter 'userCertificateId' must be defined.");
        url_ = url_.replace("{userCertificateId}", encodeURIComponent("" + userCertificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadUrl(_response);
        });
    }

    protected processGetDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getExamResults(completionId: string, cancelToken?: CancelToken): Promise<ResponseOfListOfOrgExamAttemptSummary> {
        let url_ = this.baseUrl + "/api/certificates/{completionId}/exam-results";
        if (completionId === undefined || completionId === null)
            throw new globalThis.Error("The parameter 'completionId' must be defined.");
        url_ = url_.replace("{completionId}", encodeURIComponent("" + completionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamResults(_response);
        });
    }

    protected processGetExamResults(response: AxiosResponse): Promise<ResponseOfListOfOrgExamAttemptSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfListOfOrgExamAttemptSummary.fromJS(resultData200);
            return Promise.resolve<ResponseOfListOfOrgExamAttemptSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfListOfOrgExamAttemptSummary>(null as any);
    }

    getExamResult(completionId: string, userExamId: string, cancelToken?: CancelToken): Promise<OrgExamResultResponse> {
        let url_ = this.baseUrl + "/api/certificates/{completionId}/exam-results/{userExamId}";
        if (completionId === undefined || completionId === null)
            throw new globalThis.Error("The parameter 'completionId' must be defined.");
        url_ = url_.replace("{completionId}", encodeURIComponent("" + completionId));
        if (userExamId === undefined || userExamId === null)
            throw new globalThis.Error("The parameter 'userExamId' must be defined.");
        url_ = url_.replace("{userExamId}", encodeURIComponent("" + userExamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamResult(_response);
        });
    }

    protected processGetExamResult(response: AxiosResponse): Promise<OrgExamResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrgExamResultResponse.fromJS(resultData200);
            return Promise.resolve<OrgExamResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgExamResultResponse>(null as any);
    }

    getCertificatesDownloadUrl(completionId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/certificates/{completionId}/certificates/download-url";
        if (completionId === undefined || completionId === null)
            throw new globalThis.Error("The parameter 'completionId' must be defined.");
        url_ = url_.replace("{completionId}", encodeURIComponent("" + completionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificatesDownloadUrl(_response);
        });
    }

    protected processGetCertificatesDownloadUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EnrollmentService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEnrollments(request: ListRequestOfEnrollmentsFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEnrollmentModel> {
        let url_ = this.baseUrl + "/api/enrollment/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollments(_response);
        });
    }

    protected processGetEnrollments(response: AxiosResponse): Promise<ListResponseOfEnrollmentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEnrollmentModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEnrollmentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEnrollmentModel>(null as any);
    }

    getEnrollmentStatuses(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/enrollment/statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollmentStatuses(_response);
        });
    }

    protected processGetEnrollmentStatuses(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getEnrollmentUsers(request: ListRequestOfEnrollmentUsersFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfEnrollmentUser> {
        let url_ = this.baseUrl + "/api/enrollment/candidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollmentUsers(_response);
        });
    }

    protected processGetEnrollmentUsers(response: AxiosResponse): Promise<ListResponseOfEnrollmentUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfEnrollmentUser.fromJS(resultData200);
            return Promise.resolve<ListResponseOfEnrollmentUser>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfEnrollmentUser>(null as any);
    }

    enrollUsers(request: EnrollUsersRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/enrollment/candidates/enroll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnrollUsers(_response);
        });
    }

    protected processEnrollUsers(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    enrollAllUsers(request: EnrollAllUsersRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/enrollment/candidates/enroll-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnrollAllUsers(_response);
        });
    }

    protected processEnrollAllUsers(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getProfessions( cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/enrollment/professions/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessions(_response);
        });
    }

    protected processGetProfessions(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }

    getLicenses( cancelToken?: CancelToken): Promise<ListResponseOfFilterLicense> {
        let url_ = this.baseUrl + "/api/enrollment/licenses/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: AxiosResponse): Promise<ListResponseOfFilterLicense> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfFilterLicense.fromJS(resultData200);
            return Promise.resolve<ListResponseOfFilterLicense>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfFilterLicense>(null as any);
    }
}

export class OrganizationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrganizationTree(userId: string | undefined, cancelToken?: CancelToken): Promise<ResponseOfOrganizationTreeItem> {
        let url_ = this.baseUrl + "/api/organization/tree?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationTree(_response);
        });
    }

    protected processGetOrganizationTree(response: AxiosResponse): Promise<ResponseOfOrganizationTreeItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfOrganizationTreeItem.fromJS(resultData200);
            return Promise.resolve<ResponseOfOrganizationTreeItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfOrganizationTreeItem>(null as any);
    }
}

export class OrganizationUserService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUsers(request: ListRequestOfUserFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfUserModel> {
        let url_ = this.baseUrl + "/api/organization-users/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<ListResponseOfUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserModel>(null as any);
    }

    saveUser(request: OrganizationUserRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/organization-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUser(_response);
        });
    }

    protected processSaveUser(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    changeAccessLevel(request: ChangeAccessLevelRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organization-users/change-access-level";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeAccessLevel(_response);
        });
    }

    protected processChangeAccessLevel(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    deactivateUser(organizationUserId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organization-users/{organizationUserId}/deactivate";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    reactivateUser(organizationUserId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organization-users/{organizationUserId}/reactivate";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateUser(_response);
        });
    }

    protected processReactivateUser(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    resendInvite(organizationUserId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/organization-users/{organizationUserId}/resend-invite";
        if (organizationUserId === undefined || organizationUserId === null)
            throw new globalThis.Error("The parameter 'organizationUserId' must be defined.");
        url_ = url_.replace("{organizationUserId}", encodeURIComponent("" + organizationUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendInvite(_response);
        });
    }

    protected processResendInvite(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    getPendingInvitations( cancelToken?: CancelToken): Promise<ResponseOfPendingInvitationsSummary> {
        let url_ = this.baseUrl + "/api/organization-users/pending-invitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingInvitations(_response);
        });
    }

    protected processGetPendingInvitations(response: AxiosResponse): Promise<ResponseOfPendingInvitationsSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfPendingInvitationsSummary.fromJS(resultData200);
            return Promise.resolve<ResponseOfPendingInvitationsSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfPendingInvitationsSummary>(null as any);
    }

    resendAllInvitations( cancelToken?: CancelToken): Promise<ResponseOfPendingInvitationsSummary> {
        let url_ = this.baseUrl + "/api/organization-users/resend-all-invitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendAllInvitations(_response);
        });
    }

    protected processResendAllInvitations(response: AxiosResponse): Promise<ResponseOfPendingInvitationsSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfPendingInvitationsSummary.fromJS(resultData200);
            return Promise.resolve<ResponseOfPendingInvitationsSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfPendingInvitationsSummary>(null as any);
    }

    getAccessLevels(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfAccessLevel> {
        let url_ = this.baseUrl + "/api/organization-users/access-levels/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessLevels(_response);
        });
    }

    protected processGetAccessLevels(response: AxiosResponse): Promise<ListResponseOfAccessLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfAccessLevel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfAccessLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfAccessLevel>(null as any);
    }

    getStatusTypes(request: ListRequestOfBaseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfIdNameModel> {
        let url_ = this.baseUrl + "/api/organization-users/status-types/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatusTypes(_response);
        });
    }

    protected processGetStatusTypes(response: AxiosResponse): Promise<ListResponseOfIdNameModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfIdNameModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfIdNameModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfIdNameModel>(null as any);
    }
}

export class CourseService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCourseDetails(courseDetailsRequest: CourseDetailsRequest | null | undefined, cancelToken?: CancelToken): Promise<HtmlString> {
        let url_ = this.baseUrl + "/api/course/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseDetails(_response);
        });
    }

    protected processGetCourseDetails(response: AxiosResponse): Promise<HtmlString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HtmlString.fromJS(resultData200);
            return Promise.resolve<HtmlString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HtmlString>(null as any);
    }

    getCourseDetailsSummary(courseDetailsRequest: CourseDetailsRequest | null | undefined, cancelToken?: CancelToken): Promise<HtmlString> {
        let url_ = this.baseUrl + "/api/course/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseDetailsSummary(_response);
        });
    }

    protected processGetCourseDetailsSummary(response: AxiosResponse): Promise<HtmlString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HtmlString.fromJS(resultData200);
            return Promise.resolve<HtmlString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HtmlString>(null as any);
    }
}

export class ImportService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createImportJob(request: CreateFileJobRequest | null | undefined, cancelToken?: CancelToken): Promise<SaveResponse> {
        let url_ = this.baseUrl + "/api/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateImportJob(_response);
        });
    }

    protected processCreateImportJob(response: AxiosResponse): Promise<SaveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveResponse.fromJS(resultData200);
            return Promise.resolve<SaveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveResponse>(null as any);
    }

    cancelJob(jobId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/import/{jobId}/cancel";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelJob(_response);
        });
    }

    protected processCancelJob(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    importFileData(importJobId: string, fileDataRequest: FileDataRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/import/data/{importJobId}/import";
        if (importJobId === undefined || importJobId === null)
            throw new globalThis.Error("The parameter 'importJobId' must be defined.");
        url_ = url_.replace("{importJobId}", encodeURIComponent("" + importJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFileData(_response);
        });
    }

    protected processImportFileData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MenuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLeftMenu( cancelToken?: CancelToken): Promise<Menu> {
        let url_ = this.baseUrl + "/api/menu/left";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeftMenu(_response);
        });
    }

    protected processGetLeftMenu(response: AxiosResponse): Promise<Menu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Menu.fromJS(resultData200);
            return Promise.resolve<Menu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Menu>(null as any);
    }

    getTopMenu( cancelToken?: CancelToken): Promise<Menu> {
        let url_ = this.baseUrl + "/api/menu/top";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopMenu(_response);
        });
    }

    protected processGetTopMenu(response: AxiosResponse): Promise<Menu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Menu.fromJS(resultData200);
            return Promise.resolve<Menu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Menu>(null as any);
    }
}

export class SettingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSiteSettings( cancelToken?: CancelToken): Promise<SiteSettings> {
        let url_ = this.baseUrl + "/api/settings/site-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteSettings(_response);
        });
    }

    protected processGetSiteSettings(response: AxiosResponse): Promise<SiteSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteSettings.fromJS(resultData200);
            return Promise.resolve<SiteSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteSettings>(null as any);
    }
}

export class AuthenticationV2Service {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loginComplete(sessionId: string | undefined, cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/logincomplete?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginComplete(_response);
        });
    }

    protected processLoginComplete(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    getAuthenticationResponse( cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/authentication-response";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthenticationResponse(_response);
        });
    }

    protected processGetAuthenticationResponse(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    stopImpersonating( cancelToken?: CancelToken): Promise<ResponseOfRedirectUrl> {
        let url_ = this.baseUrl + "/authentication/v2/stop-impersonating";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopImpersonating(_response);
        });
    }

    protected processStopImpersonating(response: AxiosResponse): Promise<ResponseOfRedirectUrl> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRedirectUrl.fromJS(resultData200);
            return Promise.resolve<ResponseOfRedirectUrl>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRedirectUrl>(null as any);
    }

    isAuthenticated( cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/authentication/v2/is-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthenticated(_response);
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    getAuthData( cancelToken?: CancelToken): Promise<AuthData> {
        let url_ = this.baseUrl + "/authentication/v2/auth-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthData(_response);
        });
    }

    protected processGetAuthData(response: AxiosResponse): Promise<AuthData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthData.fromJS(resultData200);
            return Promise.resolve<AuthData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthData>(null as any);
    }

    switchApplication( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/authentication/v2/switch-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchApplication(_response);
        });
    }

    protected processSwitchApplication(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TelemetryService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getConnectionString( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/telemetry/connection-string";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectionString(_response);
        });
    }

    protected processGetConnectionString(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ResponseOfListOfSkuFormatAndString implements IResponseOfListOfSkuFormatAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: SkuFormat[] | undefined;

    constructor(data?: IResponseOfListOfSkuFormatAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SkuFormat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSkuFormatAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuFormatAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSkuFormatAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: SkuFormat[] | undefined;
}

export class ResponseOfListOfSkuFormat extends ResponseOfListOfSkuFormatAndString implements IResponseOfListOfSkuFormat {

    constructor(data?: IResponseOfListOfSkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSkuFormat extends IResponseOfListOfSkuFormatAndString {
}

export class ListResponseOfSkuFormat extends ResponseOfListOfSkuFormat implements IListResponseOfSkuFormat {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfSkuFormat) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSkuFormat();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSkuFormat extends IResponseOfListOfSkuFormat {
    totalRecords: number | undefined;
}

export enum ResponseCode {
    OK = "OK",
    UserDeleted = "UserDeleted",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    ValidationFailed = "ValidationFailed",
    NotFound = "NotFound",
    BusinessRuleFailed = "BusinessRuleFailed",
    AuthenticationExpired = "AuthenticationExpired",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    InternalServerError = "InternalServerError",
    ServiceUnavailable = "ServiceUnavailable",
}

export class SkuFormat implements ISkuFormat {
    id!: string;
    name!: string | undefined;
    plainTextName!: string | undefined;
    acronym!: string | undefined;

    constructor(data?: ISkuFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plainTextName = _data["plainTextName"];
            this.acronym = _data["acronym"];
        }
    }

    static fromJS(data: any): SkuFormat {
        data = typeof data === 'object' ? data : {};
        let result = new SkuFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plainTextName"] = this.plainTextName;
        data["acronym"] = this.acronym;
        return data;
    }
}

export interface ISkuFormat {
    id: string;
    name: string | undefined;
    plainTextName: string | undefined;
    acronym: string | undefined;
}

export class ResponseOfListOfLiveOnlineCourseModelAndString implements IResponseOfListOfLiveOnlineCourseModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: LiveOnlineCourseModel[] | undefined;

    constructor(data?: IResponseOfListOfLiveOnlineCourseModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LiveOnlineCourseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfLiveOnlineCourseModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLiveOnlineCourseModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfLiveOnlineCourseModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: LiveOnlineCourseModel[] | undefined;
}

export class ResponseOfListOfLiveOnlineCourseModel extends ResponseOfListOfLiveOnlineCourseModelAndString implements IResponseOfListOfLiveOnlineCourseModel {

    constructor(data?: IResponseOfListOfLiveOnlineCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfLiveOnlineCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfLiveOnlineCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfLiveOnlineCourseModel extends IResponseOfListOfLiveOnlineCourseModelAndString {
}

export class ListResponseOfLiveOnlineCourseModel extends ResponseOfListOfLiveOnlineCourseModel implements IListResponseOfLiveOnlineCourseModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfLiveOnlineCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfLiveOnlineCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfLiveOnlineCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfLiveOnlineCourseModel extends IResponseOfListOfLiveOnlineCourseModel {
    totalRecords: number | undefined;
}

export class LiveOnlineCourseModel implements ILiveOnlineCourseModel {
    id!: string;
    title!: string | undefined;
    releaseDate!: Date | undefined;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    instructor!: string | undefined;
    credits!: number | undefined;

    constructor(data?: ILiveOnlineCourseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.instructor = _data["instructor"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): LiveOnlineCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOnlineCourseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["instructor"] = this.instructor;
        data["credits"] = this.credits;
        return data;
    }
}

export interface ILiveOnlineCourseModel {
    id: string;
    title: string | undefined;
    releaseDate: Date | undefined;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    instructor: string | undefined;
    credits: number | undefined;
}

export class ListRequestOfCatalogFilter implements IListRequestOfCatalogFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: CatalogFilter | undefined;

    constructor(data?: IListRequestOfCatalogFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CatalogFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCatalogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCatalogFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCatalogFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: CatalogFilter | undefined;
}

export class BaseFilter implements IBaseFilter {
    searchText!: string | undefined;
    includedIds!: string[] | undefined;
    excludedIds!: string[] | undefined;

    constructor(data?: IBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["includedIds"])) {
                this.includedIds = [] as any;
                for (let item of _data["includedIds"])
                    this.includedIds!.push(item);
            }
            if (Array.isArray(_data["excludedIds"])) {
                this.excludedIds = [] as any;
                for (let item of _data["excludedIds"])
                    this.excludedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.includedIds)) {
            data["includedIds"] = [];
            for (let item of this.includedIds)
                data["includedIds"].push(item);
        }
        if (Array.isArray(this.excludedIds)) {
            data["excludedIds"] = [];
            for (let item of this.excludedIds)
                data["excludedIds"].push(item);
        }
        return data;
    }
}

export interface IBaseFilter {
    searchText: string | undefined;
    includedIds: string[] | undefined;
    excludedIds: string[] | undefined;
}

export class CatalogFilter extends BaseFilter implements ICatalogFilter {
    topicId!: string | undefined;
    stateIds!: string[] | undefined;
    professionIds!: string[] | undefined;
    qualificationIds!: string[] | undefined;
    creditHours!: string | undefined;
    instructorId!: string | undefined;
    formatId!: string | undefined;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    dayOfWeek!: string | undefined;
    startTime!: Date | undefined;
    attributesFilters!: string[] | undefined;

    constructor(data?: ICatalogFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.topicId = _data["topicId"];
            if (Array.isArray(_data["stateIds"])) {
                this.stateIds = [] as any;
                for (let item of _data["stateIds"])
                    this.stateIds!.push(item);
            }
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
            this.creditHours = _data["creditHours"];
            this.instructorId = _data["instructorId"];
            this.formatId = _data["formatId"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.dayOfWeek = _data["dayOfWeek"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            if (Array.isArray(_data["attributesFilters"])) {
                this.attributesFilters = [] as any;
                for (let item of _data["attributesFilters"])
                    this.attributesFilters!.push(item);
            }
        }
    }

    static override fromJS(data: any): CatalogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        if (Array.isArray(this.stateIds)) {
            data["stateIds"] = [];
            for (let item of this.stateIds)
                data["stateIds"].push(item);
        }
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        data["creditHours"] = this.creditHours;
        data["instructorId"] = this.instructorId;
        data["formatId"] = this.formatId;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["dayOfWeek"] = this.dayOfWeek;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        if (Array.isArray(this.attributesFilters)) {
            data["attributesFilters"] = [];
            for (let item of this.attributesFilters)
                data["attributesFilters"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICatalogFilter extends IBaseFilter {
    topicId: string | undefined;
    stateIds: string[] | undefined;
    professionIds: string[] | undefined;
    qualificationIds: string[] | undefined;
    creditHours: string | undefined;
    instructorId: string | undefined;
    formatId: string | undefined;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    dayOfWeek: string | undefined;
    startTime: Date | undefined;
    attributesFilters: string[] | undefined;
}

export class ResponseOfListOfHomeStudyCourseModelAndString implements IResponseOfListOfHomeStudyCourseModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: HomeStudyCourseModel[] | undefined;

    constructor(data?: IResponseOfListOfHomeStudyCourseModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(HomeStudyCourseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfHomeStudyCourseModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfHomeStudyCourseModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfHomeStudyCourseModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: HomeStudyCourseModel[] | undefined;
}

export class ResponseOfListOfHomeStudyCourseModel extends ResponseOfListOfHomeStudyCourseModelAndString implements IResponseOfListOfHomeStudyCourseModel {

    constructor(data?: IResponseOfListOfHomeStudyCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfHomeStudyCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfHomeStudyCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfHomeStudyCourseModel extends IResponseOfListOfHomeStudyCourseModelAndString {
}

export class ListResponseOfHomeStudyCourseModel extends ResponseOfListOfHomeStudyCourseModel implements IListResponseOfHomeStudyCourseModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfHomeStudyCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfHomeStudyCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfHomeStudyCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfHomeStudyCourseModel extends IResponseOfListOfHomeStudyCourseModel {
    totalRecords: number | undefined;
}

export class HomeStudyCourseModel implements IHomeStudyCourseModel {
    id!: string;
    title!: string | undefined;
    releaseDate!: Date | undefined;
    credits!: number | undefined;
    format!: string | undefined;
    instructor!: string | undefined;

    constructor(data?: IHomeStudyCourseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : undefined as any;
            this.credits = _data["credits"];
            this.format = _data["format"];
            this.instructor = _data["instructor"];
        }
    }

    static fromJS(data: any): HomeStudyCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new HomeStudyCourseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["credits"] = this.credits;
        data["format"] = this.format;
        data["instructor"] = this.instructor;
        return data;
    }
}

export interface IHomeStudyCourseModel {
    id: string;
    title: string | undefined;
    releaseDate: Date | undefined;
    credits: number | undefined;
    format: string | undefined;
    instructor: string | undefined;
}

export class ResponseOfListOfSeriesModelAndString implements IResponseOfListOfSeriesModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: SeriesModel[] | undefined;

    constructor(data?: IResponseOfListOfSeriesModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SeriesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfSeriesModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSeriesModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfSeriesModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: SeriesModel[] | undefined;
}

export class ResponseOfListOfSeriesModel extends ResponseOfListOfSeriesModelAndString implements IResponseOfListOfSeriesModel {

    constructor(data?: IResponseOfListOfSeriesModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfSeriesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfSeriesModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfSeriesModel extends IResponseOfListOfSeriesModelAndString {
}

export class ListResponseOfSeriesModel extends ResponseOfListOfSeriesModel implements IListResponseOfSeriesModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfSeriesModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfSeriesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfSeriesModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfSeriesModel extends IResponseOfListOfSeriesModel {
    totalRecords: number | undefined;
}

export class SeriesModel implements ISeriesModel {
    id!: string;
    title!: string | undefined;
    credits!: number | undefined;
    modulesCount!: number;

    constructor(data?: ISeriesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.credits = _data["credits"];
            this.modulesCount = _data["modulesCount"];
        }
    }

    static fromJS(data: any): SeriesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["credits"] = this.credits;
        data["modulesCount"] = this.modulesCount;
        return data;
    }
}

export interface ISeriesModel {
    id: string;
    title: string | undefined;
    credits: number | undefined;
    modulesCount: number;
}

export class ResponseOfListOfGenericSkuFilterModelAndString implements IResponseOfListOfGenericSkuFilterModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: GenericSkuFilterModel[] | undefined;

    constructor(data?: IResponseOfListOfGenericSkuFilterModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GenericSkuFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfGenericSkuFilterModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfGenericSkuFilterModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfGenericSkuFilterModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: GenericSkuFilterModel[] | undefined;
}

export class ResponseOfListOfGenericSkuFilterModel extends ResponseOfListOfGenericSkuFilterModelAndString implements IResponseOfListOfGenericSkuFilterModel {

    constructor(data?: IResponseOfListOfGenericSkuFilterModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfGenericSkuFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfGenericSkuFilterModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfGenericSkuFilterModel extends IResponseOfListOfGenericSkuFilterModelAndString {
}

export class ListResponseOfGenericSkuFilterModel extends ResponseOfListOfGenericSkuFilterModel implements IListResponseOfGenericSkuFilterModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfGenericSkuFilterModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfGenericSkuFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfGenericSkuFilterModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfGenericSkuFilterModel extends IResponseOfListOfGenericSkuFilterModel {
    totalRecords: number | undefined;
}

export class GenericSkuFilterModel implements IGenericSkuFilterModel {
    id!: string;
    value!: string | undefined;
    organizationAttributeTypeId!: string | undefined;
    organizationAttributeTypeDisplayName!: string | undefined;
    attributeTypeId!: string | undefined;
    sequence!: number | undefined;
    metaValues!: AttributeMetaValueModel[] | undefined;

    constructor(data?: IGenericSkuFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.organizationAttributeTypeDisplayName = _data["organizationAttributeTypeDisplayName"];
            this.attributeTypeId = _data["attributeTypeId"];
            this.sequence = _data["sequence"];
            if (Array.isArray(_data["metaValues"])) {
                this.metaValues = [] as any;
                for (let item of _data["metaValues"])
                    this.metaValues!.push(AttributeMetaValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenericSkuFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericSkuFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["organizationAttributeTypeDisplayName"] = this.organizationAttributeTypeDisplayName;
        data["attributeTypeId"] = this.attributeTypeId;
        data["sequence"] = this.sequence;
        if (Array.isArray(this.metaValues)) {
            data["metaValues"] = [];
            for (let item of this.metaValues)
                data["metaValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGenericSkuFilterModel {
    id: string;
    value: string | undefined;
    organizationAttributeTypeId: string | undefined;
    organizationAttributeTypeDisplayName: string | undefined;
    attributeTypeId: string | undefined;
    sequence: number | undefined;
    metaValues: AttributeMetaValueModel[] | undefined;
}

export class AttributeMetaValueModel implements IAttributeMetaValueModel {
    id!: string | undefined;
    attributeId!: string;
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IAttributeMetaValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributeId = _data["attributeId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AttributeMetaValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeMetaValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributeId"] = this.attributeId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IAttributeMetaValueModel {
    id: string | undefined;
    attributeId: string;
    name: string | undefined;
    value: string | undefined;
}

export class CatalogFiltersRequest implements ICatalogFiltersRequest {
    typeId!: string;
    skuAvailabilityIds!: string[] | undefined;

    constructor(data?: ICatalogFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["skuAvailabilityIds"])) {
                this.skuAvailabilityIds = [] as any;
                for (let item of _data["skuAvailabilityIds"])
                    this.skuAvailabilityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CatalogFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        if (Array.isArray(this.skuAvailabilityIds)) {
            data["skuAvailabilityIds"] = [];
            for (let item of this.skuAvailabilityIds)
                data["skuAvailabilityIds"].push(item);
        }
        return data;
    }
}

export interface ICatalogFiltersRequest {
    typeId: string;
    skuAvailabilityIds: string[] | undefined;
}

export class ResponseOfListOfAttributesFilterModelAndString implements IResponseOfListOfAttributesFilterModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: AttributesFilterModel[] | undefined;

    constructor(data?: IResponseOfListOfAttributesFilterModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AttributesFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAttributesFilterModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttributesFilterModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAttributesFilterModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: AttributesFilterModel[] | undefined;
}

export class ResponseOfListOfAttributesFilterModel extends ResponseOfListOfAttributesFilterModelAndString implements IResponseOfListOfAttributesFilterModel {

    constructor(data?: IResponseOfListOfAttributesFilterModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAttributesFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAttributesFilterModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAttributesFilterModel extends IResponseOfListOfAttributesFilterModelAndString {
}

export class ListResponseOfAttributesFilterModel extends ResponseOfListOfAttributesFilterModel implements IListResponseOfAttributesFilterModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfAttributesFilterModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAttributesFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAttributesFilterModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAttributesFilterModel extends IResponseOfListOfAttributesFilterModel {
    totalRecords: number | undefined;
}

export class AttributesFilterModel implements IAttributesFilterModel {
    organizationAttributeTypeId!: string;
    organizationAttributeTypeDisplayName!: string | undefined;
    attributeTypeId!: string | undefined;
    attributes!: GenericSkuFilterModel[] | undefined;

    constructor(data?: IAttributesFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationAttributeTypeId = _data["organizationAttributeTypeId"];
            this.organizationAttributeTypeDisplayName = _data["organizationAttributeTypeDisplayName"];
            this.attributeTypeId = _data["attributeTypeId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(GenericSkuFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributesFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttributesFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationAttributeTypeId"] = this.organizationAttributeTypeId;
        data["organizationAttributeTypeDisplayName"] = this.organizationAttributeTypeDisplayName;
        data["attributeTypeId"] = this.attributeTypeId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttributesFilterModel {
    organizationAttributeTypeId: string;
    organizationAttributeTypeDisplayName: string | undefined;
    attributeTypeId: string | undefined;
    attributes: GenericSkuFilterModel[] | undefined;
}

export class CatalogAttributesFilterRequest implements ICatalogAttributesFilterRequest {
    skuAvailabilityIds!: string[] | undefined;

    constructor(data?: ICatalogAttributesFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["skuAvailabilityIds"])) {
                this.skuAvailabilityIds = [] as any;
                for (let item of _data["skuAvailabilityIds"])
                    this.skuAvailabilityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CatalogAttributesFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogAttributesFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.skuAvailabilityIds)) {
            data["skuAvailabilityIds"] = [];
            for (let item of this.skuAvailabilityIds)
                data["skuAvailabilityIds"].push(item);
        }
        return data;
    }
}

export interface ICatalogAttributesFilterRequest {
    skuAvailabilityIds: string[] | undefined;
}

export class ResponseOfListOfOrganizationCompletionAndString implements IResponseOfListOfOrganizationCompletionAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: OrganizationCompletion[] | undefined;

    constructor(data?: IResponseOfListOfOrganizationCompletionAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationCompletion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrganizationCompletionAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCompletionAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrganizationCompletionAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: OrganizationCompletion[] | undefined;
}

export class ResponseOfListOfOrganizationCompletion extends ResponseOfListOfOrganizationCompletionAndString implements IResponseOfListOfOrganizationCompletion {

    constructor(data?: IResponseOfListOfOrganizationCompletion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrganizationCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrganizationCompletion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrganizationCompletion extends IResponseOfListOfOrganizationCompletionAndString {
}

export class ListResponseOfOrganizationCompletion extends ResponseOfListOfOrganizationCompletion implements IListResponseOfOrganizationCompletion {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfOrganizationCompletion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfOrganizationCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfOrganizationCompletion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfOrganizationCompletion extends IResponseOfListOfOrganizationCompletion {
    totalRecords: number | undefined;
}

export class OrganizationCompletion implements IOrganizationCompletion {
    id!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    courseTitle!: string | undefined;
    skuFormat!: SkuFormat | undefined;
    skuAvailability!: SkuAvailability | undefined;
    completionDate!: Date;
    userCertificates!: OrganizationUserCertificate[] | undefined;
    userId!: string;
    userSkuId!: string | undefined;

    constructor(data?: IOrganizationCompletion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.courseTitle = _data["courseTitle"];
            this.skuFormat = _data["skuFormat"] ? SkuFormat.fromJS(_data["skuFormat"]) : undefined as any;
            this.skuAvailability = _data["skuAvailability"] ? SkuAvailability.fromJS(_data["skuAvailability"]) : undefined as any;
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["userCertificates"])) {
                this.userCertificates = [] as any;
                for (let item of _data["userCertificates"])
                    this.userCertificates!.push(OrganizationUserCertificate.fromJS(item));
            }
            this.userId = _data["userId"];
            this.userSkuId = _data["userSkuId"];
        }
    }

    static fromJS(data: any): OrganizationCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCompletion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["courseTitle"] = this.courseTitle;
        data["skuFormat"] = this.skuFormat ? this.skuFormat.toJSON() : undefined as any;
        data["skuAvailability"] = this.skuAvailability ? this.skuAvailability.toJSON() : undefined as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : undefined as any;
        if (Array.isArray(this.userCertificates)) {
            data["userCertificates"] = [];
            for (let item of this.userCertificates)
                data["userCertificates"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        data["userSkuId"] = this.userSkuId;
        return data;
    }
}

export interface IOrganizationCompletion {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    courseTitle: string | undefined;
    skuFormat: SkuFormat | undefined;
    skuAvailability: SkuAvailability | undefined;
    completionDate: Date;
    userCertificates: OrganizationUserCertificate[] | undefined;
    userId: string;
    userSkuId: string | undefined;
}

export class SkuAvailability implements ISkuAvailability {
    id!: string;
    name!: string | undefined;
    codeConstant!: string | undefined;

    constructor(data?: ISkuAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.codeConstant = _data["codeConstant"];
        }
    }

    static fromJS(data: any): SkuAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new SkuAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["codeConstant"] = this.codeConstant;
        return data;
    }
}

export interface ISkuAvailability {
    id: string;
    name: string | undefined;
    codeConstant: string | undefined;
}

export class OrganizationUserCertificate implements IOrganizationUserCertificate {
    id!: string;
    userId!: string;
    credits!: number;
    professionId!: string | undefined;
    professionName!: string | undefined;
    qualificationId!: string | undefined;
    qualificationName!: string | undefined;

    constructor(data?: IOrganizationUserCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.credits = _data["credits"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationName = _data["qualificationName"];
        }
    }

    static fromJS(data: any): OrganizationUserCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["credits"] = this.credits;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["qualificationId"] = this.qualificationId;
        data["qualificationName"] = this.qualificationName;
        return data;
    }
}

export interface IOrganizationUserCertificate {
    id: string;
    userId: string;
    credits: number;
    professionId: string | undefined;
    professionName: string | undefined;
    qualificationId: string | undefined;
    qualificationName: string | undefined;
}

export class ListRequestOfCompletionsFilter implements IListRequestOfCompletionsFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: CompletionsFilter | undefined;

    constructor(data?: IListRequestOfCompletionsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CompletionsFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCompletionsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCompletionsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCompletionsFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: CompletionsFilter | undefined;
}

export class CompletionsFilter extends BaseFilter implements ICompletionsFilter {
    skuFormatId!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    professionIds!: string[] | undefined;

    constructor(data?: ICompletionsFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuFormatId = _data["skuFormatId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): CompletionsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CompletionsFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuFormatId"] = this.skuFormatId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompletionsFilter extends IBaseFilter {
    skuFormatId: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    professionIds: string[] | undefined;
}

export class ResponseOfListOfProfessionModelAndString implements IResponseOfListOfProfessionModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: ProfessionModel[] | undefined;

    constructor(data?: IResponseOfListOfProfessionModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProfessionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfProfessionModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfessionModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfProfessionModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: ProfessionModel[] | undefined;
}

export class ResponseOfListOfProfessionModel extends ResponseOfListOfProfessionModelAndString implements IResponseOfListOfProfessionModel {

    constructor(data?: IResponseOfListOfProfessionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfProfessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfProfessionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfProfessionModel extends IResponseOfListOfProfessionModelAndString {
}

export class ListResponseOfProfessionModel extends ResponseOfListOfProfessionModel implements IListResponseOfProfessionModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfProfessionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfProfessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfProfessionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfProfessionModel extends IResponseOfListOfProfessionModel {
    totalRecords: number | undefined;
}

export class ProfessionModel implements IProfessionModel {
    id!: string;
    name!: string | undefined;

    constructor(data?: IProfessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProfessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProfessionModel {
    id: string;
    name: string | undefined;
}

export class ResponseOfCreatePdfFromHtmlResponseAndString implements IResponseOfCreatePdfFromHtmlResponseAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: CreatePdfFromHtmlResponse | undefined;

    constructor(data?: IResponseOfCreatePdfFromHtmlResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? CreatePdfFromHtmlResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfCreatePdfFromHtmlResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCreatePdfFromHtmlResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfCreatePdfFromHtmlResponseAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: CreatePdfFromHtmlResponse | undefined;
}

export class ResponseOfCreatePdfFromHtmlResponse extends ResponseOfCreatePdfFromHtmlResponseAndString implements IResponseOfCreatePdfFromHtmlResponse {

    constructor(data?: IResponseOfCreatePdfFromHtmlResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfCreatePdfFromHtmlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfCreatePdfFromHtmlResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfCreatePdfFromHtmlResponse extends IResponseOfCreatePdfFromHtmlResponseAndString {
}

export class CreatePdfFromHtmlResponse implements ICreatePdfFromHtmlResponse {
    downloadUrl!: string | undefined;

    constructor(data?: ICreatePdfFromHtmlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): CreatePdfFromHtmlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdfFromHtmlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface ICreatePdfFromHtmlResponse {
    downloadUrl: string | undefined;
}

export class ExportCertificatesRequest implements IExportCertificatesRequest {
    completionsRequest!: ListRequestOfCompletionsFilter | undefined;
    fileName!: string | undefined;

    constructor(data?: IExportCertificatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completionsRequest = _data["completionsRequest"] ? ListRequestOfCompletionsFilter.fromJS(_data["completionsRequest"]) : undefined as any;
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ExportCertificatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCertificatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completionsRequest"] = this.completionsRequest ? this.completionsRequest.toJSON() : undefined as any;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IExportCertificatesRequest {
    completionsRequest: ListRequestOfCompletionsFilter | undefined;
    fileName: string | undefined;
}

export class ResponseOfListOfOrgExamAttemptSummaryAndString implements IResponseOfListOfOrgExamAttemptSummaryAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: OrgExamAttemptSummary[] | undefined;

    constructor(data?: IResponseOfListOfOrgExamAttemptSummaryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrgExamAttemptSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfOrgExamAttemptSummaryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrgExamAttemptSummaryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfOrgExamAttemptSummaryAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: OrgExamAttemptSummary[] | undefined;
}

export class ResponseOfListOfOrgExamAttemptSummary extends ResponseOfListOfOrgExamAttemptSummaryAndString implements IResponseOfListOfOrgExamAttemptSummary {

    constructor(data?: IResponseOfListOfOrgExamAttemptSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfOrgExamAttemptSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfOrgExamAttemptSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfOrgExamAttemptSummary extends IResponseOfListOfOrgExamAttemptSummaryAndString {
}

export class OrgExamAttemptSummary implements IOrgExamAttemptSummary {
    id!: string;
    endDateTime!: Date | undefined;
    score!: number;
    formattedScore!: string | undefined;
    passed!: boolean;
    skuId!: string;
    attemptNumber!: number | undefined;

    constructor(data?: IOrgExamAttemptSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.score = _data["score"];
            this.formattedScore = _data["formattedScore"];
            this.passed = _data["passed"];
            this.skuId = _data["skuId"];
            this.attemptNumber = _data["attemptNumber"];
        }
    }

    static fromJS(data: any): OrgExamAttemptSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrgExamAttemptSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["score"] = this.score;
        data["formattedScore"] = this.formattedScore;
        data["passed"] = this.passed;
        data["skuId"] = this.skuId;
        data["attemptNumber"] = this.attemptNumber;
        return data;
    }
}

export interface IOrgExamAttemptSummary {
    id: string;
    endDateTime: Date | undefined;
    score: number;
    formattedScore: string | undefined;
    passed: boolean;
    skuId: string;
    attemptNumber: number | undefined;
}

export class OrgExamResultResponse implements IOrgExamResultResponse {
    result!: UserExamResult | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;

    constructor(data?: IOrgExamResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserExamResult.fromJS(_data["result"]) : undefined as any;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OrgExamResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgExamResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IOrgExamResultResponse {
    result: UserExamResult | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export class UserExamResult implements IUserExamResult {
    examId!: string;
    skuId!: string;
    userSkuId!: string;
    examName!: string | undefined;
    attemptsAllowed!: number | undefined;
    passingScore!: number | undefined;
    score!: number | undefined;
    examPassed!: boolean | undefined;
    userAttemptsCount!: number;
    questionsCount!: number;
    isGradingPending!: boolean;
    enablePrintReference!: boolean | undefined;
    attemptDate!: Date | undefined;
    attemptNumber!: number | undefined;
    questions!: UserExamResultQuestion[] | undefined;

    constructor(data?: IUserExamResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.skuId = _data["skuId"];
            this.userSkuId = _data["userSkuId"];
            this.examName = _data["examName"];
            this.attemptsAllowed = _data["attemptsAllowed"];
            this.passingScore = _data["passingScore"];
            this.score = _data["score"];
            this.examPassed = _data["examPassed"];
            this.userAttemptsCount = _data["userAttemptsCount"];
            this.questionsCount = _data["questionsCount"];
            this.isGradingPending = _data["isGradingPending"];
            this.enablePrintReference = _data["enablePrintReference"];
            this.attemptDate = _data["attemptDate"] ? new Date(_data["attemptDate"].toString()) : undefined as any;
            this.attemptNumber = _data["attemptNumber"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(UserExamResultQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserExamResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["skuId"] = this.skuId;
        data["userSkuId"] = this.userSkuId;
        data["examName"] = this.examName;
        data["attemptsAllowed"] = this.attemptsAllowed;
        data["passingScore"] = this.passingScore;
        data["score"] = this.score;
        data["examPassed"] = this.examPassed;
        data["userAttemptsCount"] = this.userAttemptsCount;
        data["questionsCount"] = this.questionsCount;
        data["isGradingPending"] = this.isGradingPending;
        data["enablePrintReference"] = this.enablePrintReference;
        data["attemptDate"] = this.attemptDate ? this.attemptDate.toISOString() : undefined as any;
        data["attemptNumber"] = this.attemptNumber;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserExamResult {
    examId: string;
    skuId: string;
    userSkuId: string;
    examName: string | undefined;
    attemptsAllowed: number | undefined;
    passingScore: number | undefined;
    score: number | undefined;
    examPassed: boolean | undefined;
    userAttemptsCount: number;
    questionsCount: number;
    isGradingPending: boolean;
    enablePrintReference: boolean | undefined;
    attemptDate: Date | undefined;
    attemptNumber: number | undefined;
    questions: UserExamResultQuestion[] | undefined;
}

export class UserExamResultQuestion implements IUserExamResultQuestion {
    question!: string | undefined;
    score!: number | undefined;
    questionTypeId!: string;
    questionId!: string;
    questionNumber!: number | undefined;
    questionFeedback!: string | undefined;
    answers!: UserExamResultAnswer[] | undefined;

    constructor(data?: IUserExamResultQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.score = _data["score"];
            this.questionTypeId = _data["questionTypeId"];
            this.questionId = _data["questionId"];
            this.questionNumber = _data["questionNumber"];
            this.questionFeedback = _data["questionFeedback"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(UserExamResultAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserExamResultQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResultQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["score"] = this.score;
        data["questionTypeId"] = this.questionTypeId;
        data["questionId"] = this.questionId;
        data["questionNumber"] = this.questionNumber;
        data["questionFeedback"] = this.questionFeedback;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserExamResultQuestion {
    question: string | undefined;
    score: number | undefined;
    questionTypeId: string;
    questionId: string;
    questionNumber: number | undefined;
    questionFeedback: string | undefined;
    answers: UserExamResultAnswer[] | undefined;
}

export class UserExamResultAnswer implements IUserExamResultAnswer {
    id!: string;
    isAnswer!: boolean | undefined;
    isSelectedAnswer!: boolean;
    answerText!: string | undefined;
    value!: string | undefined;
    feedback!: string | undefined;

    constructor(data?: IUserExamResultAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAnswer = _data["isAnswer"];
            this.isSelectedAnswer = _data["isSelectedAnswer"];
            this.answerText = _data["answerText"];
            this.value = _data["value"];
            this.feedback = _data["feedback"];
        }
    }

    static fromJS(data: any): UserExamResultAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResultAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAnswer"] = this.isAnswer;
        data["isSelectedAnswer"] = this.isSelectedAnswer;
        data["answerText"] = this.answerText;
        data["value"] = this.value;
        data["feedback"] = this.feedback;
        return data;
    }
}

export interface IUserExamResultAnswer {
    id: string;
    isAnswer: boolean | undefined;
    isSelectedAnswer: boolean;
    answerText: string | undefined;
    value: string | undefined;
    feedback: string | undefined;
}

export class ResponseOfListOfEnrollmentModelAndString implements IResponseOfListOfEnrollmentModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: EnrollmentModel[] | undefined;

    constructor(data?: IResponseOfListOfEnrollmentModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnrollmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEnrollmentModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEnrollmentModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEnrollmentModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: EnrollmentModel[] | undefined;
}

export class ResponseOfListOfEnrollmentModel extends ResponseOfListOfEnrollmentModelAndString implements IResponseOfListOfEnrollmentModel {

    constructor(data?: IResponseOfListOfEnrollmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEnrollmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEnrollmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEnrollmentModel extends IResponseOfListOfEnrollmentModelAndString {
}

export class ListResponseOfEnrollmentModel extends ResponseOfListOfEnrollmentModel implements IListResponseOfEnrollmentModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfEnrollmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEnrollmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEnrollmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEnrollmentModel extends IResponseOfListOfEnrollmentModel {
    totalRecords: number | undefined;
}

export class EnrollmentModel implements IEnrollmentModel {
    id!: string;
    skuId!: string;
    userSkuId!: string | undefined;
    skuFormatId!: string | undefined;
    enrollmentDate!: Date;
    assignedBy!: EnrollmentAssigner;
    status!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    title!: string | undefined;
    availability!: string | undefined;
    skuFormat!: SkuFormat2 | undefined;
    credits!: number | undefined;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    professions!: IdNameModel[] | undefined;

    constructor(data?: IEnrollmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.userSkuId = _data["userSkuId"];
            this.skuFormatId = _data["skuFormatId"];
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : undefined as any;
            this.assignedBy = _data["assignedBy"];
            this.status = _data["status"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.availability = _data["availability"];
            this.skuFormat = _data["skuFormat"] ? SkuFormat2.fromJS(_data["skuFormat"]) : undefined as any;
            this.credits = _data["credits"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnrollmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["userSkuId"] = this.userSkuId;
        data["skuFormatId"] = this.skuFormatId;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : undefined as any;
        data["assignedBy"] = this.assignedBy;
        data["status"] = this.status;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["title"] = this.title;
        data["availability"] = this.availability;
        data["skuFormat"] = this.skuFormat ? this.skuFormat.toJSON() : undefined as any;
        data["credits"] = this.credits;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnrollmentModel {
    id: string;
    skuId: string;
    userSkuId: string | undefined;
    skuFormatId: string | undefined;
    enrollmentDate: Date;
    assignedBy: EnrollmentAssigner;
    status: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    title: string | undefined;
    availability: string | undefined;
    skuFormat: SkuFormat2 | undefined;
    credits: number | undefined;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    professions: IdNameModel[] | undefined;
}

export enum EnrollmentAssigner {
    None = "None",
    SelfUser = "SelfUser",
    Administrator = "Administrator",
}

export class SkuFormat2 implements ISkuFormat2 {
    plainTextName!: string | undefined;

    constructor(data?: ISkuFormat2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plainTextName = _data["plainTextName"];
        }
    }

    static fromJS(data: any): SkuFormat2 {
        data = typeof data === 'object' ? data : {};
        let result = new SkuFormat2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plainTextName"] = this.plainTextName;
        return data;
    }
}

export interface ISkuFormat2 {
    plainTextName: string | undefined;
}

export class IdNameModel implements IIdNameModel {
    id!: string;
    name!: string | undefined;

    constructor(data?: IIdNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIdNameModel {
    id: string;
    name: string | undefined;
}

export class ListRequestOfEnrollmentsFilter implements IListRequestOfEnrollmentsFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: EnrollmentsFilter | undefined;

    constructor(data?: IListRequestOfEnrollmentsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? EnrollmentsFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfEnrollmentsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfEnrollmentsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfEnrollmentsFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: EnrollmentsFilter | undefined;
}

export class EnrollmentsFilter extends BaseFilter implements IEnrollmentsFilter {
    assignedBy!: EnrollmentAssigner | undefined;
    enrollmentStatusId!: string | undefined;
    enrollmentStartDate!: Date | undefined;
    enrollmentEndDate!: Date | undefined;
    professionIds!: string[] | undefined;

    constructor(data?: IEnrollmentsFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assignedBy = _data["assignedBy"];
            this.enrollmentStatusId = _data["enrollmentStatusId"];
            this.enrollmentStartDate = _data["enrollmentStartDate"] ? new Date(_data["enrollmentStartDate"].toString()) : undefined as any;
            this.enrollmentEndDate = _data["enrollmentEndDate"] ? new Date(_data["enrollmentEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): EnrollmentsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentsFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedBy"] = this.assignedBy;
        data["enrollmentStatusId"] = this.enrollmentStatusId;
        data["enrollmentStartDate"] = this.enrollmentStartDate ? this.enrollmentStartDate.toISOString() : undefined as any;
        data["enrollmentEndDate"] = this.enrollmentEndDate ? this.enrollmentEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEnrollmentsFilter extends IBaseFilter {
    assignedBy: EnrollmentAssigner | undefined;
    enrollmentStatusId: string | undefined;
    enrollmentStartDate: Date | undefined;
    enrollmentEndDate: Date | undefined;
    professionIds: string[] | undefined;
}

export class ResponseOfListOfIdNameModelAndString implements IResponseOfListOfIdNameModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: IdNameModel[] | undefined;

    constructor(data?: IResponseOfListOfIdNameModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfIdNameModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIdNameModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfIdNameModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: IdNameModel[] | undefined;
}

export class ResponseOfListOfIdNameModel extends ResponseOfListOfIdNameModelAndString implements IResponseOfListOfIdNameModel {

    constructor(data?: IResponseOfListOfIdNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfIdNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfIdNameModel extends IResponseOfListOfIdNameModelAndString {
}

export class ListResponseOfIdNameModel extends ResponseOfListOfIdNameModel implements IListResponseOfIdNameModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfIdNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfIdNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfIdNameModel extends IResponseOfListOfIdNameModel {
    totalRecords: number | undefined;
}

export class ListRequestOfBaseFilter implements IListRequestOfBaseFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: BaseFilter | undefined;

    constructor(data?: IListRequestOfBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? BaseFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfBaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfBaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfBaseFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: BaseFilter | undefined;
}

export class ResponseOfListOfEnrollmentUserAndString implements IResponseOfListOfEnrollmentUserAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: EnrollmentUser[] | undefined;

    constructor(data?: IResponseOfListOfEnrollmentUserAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnrollmentUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfEnrollmentUserAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEnrollmentUserAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfEnrollmentUserAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: EnrollmentUser[] | undefined;
}

export class ResponseOfListOfEnrollmentUser extends ResponseOfListOfEnrollmentUserAndString implements IResponseOfListOfEnrollmentUser {

    constructor(data?: IResponseOfListOfEnrollmentUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfEnrollmentUser {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfEnrollmentUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfEnrollmentUser extends IResponseOfListOfEnrollmentUserAndString {
}

export class ListResponseOfEnrollmentUser extends ResponseOfListOfEnrollmentUser implements IListResponseOfEnrollmentUser {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfEnrollmentUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfEnrollmentUser {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfEnrollmentUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfEnrollmentUser extends IResponseOfListOfEnrollmentUser {
    totalRecords: number | undefined;
}

export class EnrollmentUser implements IEnrollmentUser {
    id!: string;
    accessLevelName!: string | undefined;
    email!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    isEnrolled!: boolean;
    hasPriorCompletion!: boolean;

    constructor(data?: IEnrollmentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessLevelName = _data["accessLevelName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isEnrolled = _data["isEnrolled"];
            this.hasPriorCompletion = _data["hasPriorCompletion"];
        }
    }

    static fromJS(data: any): EnrollmentUser {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessLevelName"] = this.accessLevelName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isEnrolled"] = this.isEnrolled;
        data["hasPriorCompletion"] = this.hasPriorCompletion;
        return data;
    }
}

export interface IEnrollmentUser {
    id: string;
    accessLevelName: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    isEnrolled: boolean;
    hasPriorCompletion: boolean;
}

export class ListRequestOfEnrollmentUsersFilter implements IListRequestOfEnrollmentUsersFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: EnrollmentUsersFilter | undefined;

    constructor(data?: IListRequestOfEnrollmentUsersFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? EnrollmentUsersFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfEnrollmentUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfEnrollmentUsersFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfEnrollmentUsersFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: EnrollmentUsersFilter | undefined;
}

export class EnrollmentUsersFilter extends BaseFilter implements IEnrollmentUsersFilter {
    skuId!: string;
    professionIds!: string[] | undefined;
    licenses!: UserLicenseFilter[] | undefined;
    excludeCompleted!: boolean | undefined;
    excludeEnrolled!: boolean | undefined;

    constructor(data?: IEnrollmentUsersFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.skuId = _data["skuId"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(UserLicenseFilter.fromJS(item));
            }
            this.excludeCompleted = _data["excludeCompleted"];
            this.excludeEnrolled = _data["excludeEnrolled"];
        }
    }

    static override fromJS(data: any): EnrollmentUsersFilter {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentUsersFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        data["excludeCompleted"] = this.excludeCompleted;
        data["excludeEnrolled"] = this.excludeEnrolled;
        super.toJSON(data);
        return data;
    }
}

export interface IEnrollmentUsersFilter extends IBaseFilter {
    skuId: string;
    professionIds: string[] | undefined;
    licenses: UserLicenseFilter[] | undefined;
    excludeCompleted: boolean | undefined;
    excludeEnrolled: boolean | undefined;
}

export class UserLicenseFilter implements IUserLicenseFilter {
    licensureBodyId!: string | undefined;
    stateId!: string | undefined;

    constructor(data?: IUserLicenseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.stateId = _data["stateId"];
        }
    }

    static fromJS(data: any): UserLicenseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["stateId"] = this.stateId;
        return data;
    }
}

export interface IUserLicenseFilter {
    licensureBodyId: string | undefined;
    stateId: string | undefined;
}

export class Response implements IResponse {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        return data;
    }
}

export interface IResponse {
    responseCode: ResponseCode;
    responseReason: string | undefined;
}

export class EnrollUsersRequest implements IEnrollUsersRequest {
    skuId!: string;
    userIds!: string[] | undefined;

    constructor(data?: IEnrollUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EnrollUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface IEnrollUsersRequest {
    skuId: string;
    userIds: string[] | undefined;
}

export class EnrollAllUsersRequest implements IEnrollAllUsersRequest {
    skuId!: string;

    constructor(data?: IEnrollAllUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
        }
    }

    static fromJS(data: any): EnrollAllUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollAllUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        return data;
    }
}

export interface IEnrollAllUsersRequest {
    skuId: string;
}

export class ResponseOfListOfFilterLicenseAndString implements IResponseOfListOfFilterLicenseAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: FilterLicense[] | undefined;

    constructor(data?: IResponseOfListOfFilterLicenseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilterLicense.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfFilterLicenseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfFilterLicenseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfFilterLicenseAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: FilterLicense[] | undefined;
}

export class ResponseOfListOfFilterLicense extends ResponseOfListOfFilterLicenseAndString implements IResponseOfListOfFilterLicense {

    constructor(data?: IResponseOfListOfFilterLicense) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfFilterLicense {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfFilterLicense();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfFilterLicense extends IResponseOfListOfFilterLicenseAndString {
}

export class ListResponseOfFilterLicense extends ResponseOfListOfFilterLicense implements IListResponseOfFilterLicense {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfFilterLicense) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfFilterLicense {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfFilterLicense();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfFilterLicense extends IResponseOfListOfFilterLicense {
    totalRecords: number | undefined;
}

export class FilterLicense implements IFilterLicense {
    licensureBodyId!: string | undefined;
    licensureBodyName!: string | undefined;
    licensureBodyAcronym!: string | undefined;
    stateId!: string | undefined;
    stateName!: string | undefined;

    constructor(data?: IFilterLicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensureBodyId = _data["licensureBodyId"];
            this.licensureBodyName = _data["licensureBodyName"];
            this.licensureBodyAcronym = _data["licensureBodyAcronym"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): FilterLicense {
        data = typeof data === 'object' ? data : {};
        let result = new FilterLicense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensureBodyId"] = this.licensureBodyId;
        data["licensureBodyName"] = this.licensureBodyName;
        data["licensureBodyAcronym"] = this.licensureBodyAcronym;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IFilterLicense {
    licensureBodyId: string | undefined;
    licensureBodyName: string | undefined;
    licensureBodyAcronym: string | undefined;
    stateId: string | undefined;
    stateName: string | undefined;
}

export class ResponseOfOrganizationTreeItemAndString implements IResponseOfOrganizationTreeItemAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: OrganizationTreeItem | undefined;

    constructor(data?: IResponseOfOrganizationTreeItemAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? OrganizationTreeItem.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfOrganizationTreeItemAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationTreeItemAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfOrganizationTreeItemAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: OrganizationTreeItem | undefined;
}

export class ResponseOfOrganizationTreeItem extends ResponseOfOrganizationTreeItemAndString implements IResponseOfOrganizationTreeItem {

    constructor(data?: IResponseOfOrganizationTreeItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfOrganizationTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfOrganizationTreeItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfOrganizationTreeItem extends IResponseOfOrganizationTreeItemAndString {
}

export class OrganizationTreeItem implements IOrganizationTreeItem {
    id!: string;
    name!: string | undefined;
    displayName!: string | undefined;
    isDisplayOnly!: boolean;
    organizationTypeId!: string;
    organizations!: OrganizationTreeItem[] | undefined;

    constructor(data?: IOrganizationTreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDisplayOnly = _data["isDisplayOnly"];
            this.organizationTypeId = _data["organizationTypeId"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationTreeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDisplayOnly"] = this.isDisplayOnly;
        data["organizationTypeId"] = this.organizationTypeId;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationTreeItem {
    id: string;
    name: string | undefined;
    displayName: string | undefined;
    isDisplayOnly: boolean;
    organizationTypeId: string;
    organizations: OrganizationTreeItem[] | undefined;
}

export class ResponseOfListOfUserModelAndString implements IResponseOfListOfUserModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: UserModel[] | undefined;

    constructor(data?: IResponseOfListOfUserModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfUserModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfUserModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: UserModel[] | undefined;
}

export class ResponseOfListOfUserModel extends ResponseOfListOfUserModelAndString implements IResponseOfListOfUserModel {

    constructor(data?: IResponseOfListOfUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfUserModel extends IResponseOfListOfUserModelAndString {
}

export class ListResponseOfUserModel extends ResponseOfListOfUserModel implements IListResponseOfUserModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfUserModel extends IResponseOfListOfUserModel {
    totalRecords: number | undefined;
}

export class UserModel implements IUserModel {
    id!: string;
    organizationId!: string;
    statusTypeName!: string | undefined;
    accessLevelId!: string | undefined;
    accessLevelName!: string | undefined;
    email!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    professions!: IdNameModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.statusTypeName = _data["statusTypeName"];
            this.accessLevelId = _data["accessLevelId"];
            this.accessLevelName = _data["accessLevelName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["statusTypeName"] = this.statusTypeName;
        data["accessLevelId"] = this.accessLevelId;
        data["accessLevelName"] = this.accessLevelName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserModel {
    id: string;
    organizationId: string;
    statusTypeName: string | undefined;
    accessLevelId: string | undefined;
    accessLevelName: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    professions: IdNameModel[] | undefined;
}

export class ListRequestOfUserFilter implements IListRequestOfUserFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: UserFilter | undefined;

    constructor(data?: IListRequestOfUserFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? UserFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfUserFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfUserFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfUserFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: UserFilter | undefined;
}

export class UserFilter extends BaseFilter implements IUserFilter {
    statusTypeId!: string | undefined;
    accessLevelId!: string | undefined;
    professionIds!: string[] | undefined;
    licenses!: UserLicenseFilter[] | undefined;

    constructor(data?: IUserFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusTypeId = _data["statusTypeId"];
            this.accessLevelId = _data["accessLevelId"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(UserLicenseFilter.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UserFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusTypeId"] = this.statusTypeId;
        data["accessLevelId"] = this.accessLevelId;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserFilter extends IBaseFilter {
    statusTypeId: string | undefined;
    accessLevelId: string | undefined;
    professionIds: string[] | undefined;
    licenses: UserLicenseFilter[] | undefined;
}

export class SaveResponse implements ISaveResponse {
    responseCode!: ResponseCode;
    id!: string;
    responseReason!: string | undefined;

    constructor(data?: ISaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.id = _data["id"];
            this.responseReason = _data["responseReason"];
        }
    }

    static fromJS(data: any): SaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["id"] = this.id;
        data["responseReason"] = this.responseReason;
        return data;
    }
}

export interface ISaveResponse {
    responseCode: ResponseCode;
    id: string;
    responseReason: string | undefined;
}

export class OrganizationUserRequest implements IOrganizationUserRequest {
    id!: string | undefined;
    firstName!: string;
    lastName!: string;
    email!: string;
    accessLevelId!: string;

    constructor(data?: IOrganizationUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.accessLevelId = _data["accessLevelId"];
        }
    }

    static fromJS(data: any): OrganizationUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["accessLevelId"] = this.accessLevelId;
        return data;
    }
}

export interface IOrganizationUserRequest {
    id: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    accessLevelId: string;
}

export class ChangeAccessLevelRequest implements IChangeAccessLevelRequest {
    organizationUserId!: string;
    accessLevelId!: string;

    constructor(data?: IChangeAccessLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUserId = _data["organizationUserId"];
            this.accessLevelId = _data["accessLevelId"];
        }
    }

    static fromJS(data: any): ChangeAccessLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeAccessLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUserId"] = this.organizationUserId;
        data["accessLevelId"] = this.accessLevelId;
        return data;
    }
}

export interface IChangeAccessLevelRequest {
    organizationUserId: string;
    accessLevelId: string;
}

export class ResponseOfPendingInvitationsSummaryAndString implements IResponseOfPendingInvitationsSummaryAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: PendingInvitationsSummary | undefined;

    constructor(data?: IResponseOfPendingInvitationsSummaryAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? PendingInvitationsSummary.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfPendingInvitationsSummaryAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfPendingInvitationsSummaryAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfPendingInvitationsSummaryAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: PendingInvitationsSummary | undefined;
}

export class ResponseOfPendingInvitationsSummary extends ResponseOfPendingInvitationsSummaryAndString implements IResponseOfPendingInvitationsSummary {

    constructor(data?: IResponseOfPendingInvitationsSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfPendingInvitationsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfPendingInvitationsSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfPendingInvitationsSummary extends IResponseOfPendingInvitationsSummaryAndString {
}

export class PendingInvitationsSummary implements IPendingInvitationsSummary {
    pendingUserCount!: number;

    constructor(data?: IPendingInvitationsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingUserCount = _data["pendingUserCount"];
        }
    }

    static fromJS(data: any): PendingInvitationsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PendingInvitationsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingUserCount"] = this.pendingUserCount;
        return data;
    }
}

export interface IPendingInvitationsSummary {
    pendingUserCount: number;
}

export class ResponseOfListOfAccessLevelAndString implements IResponseOfListOfAccessLevelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: AccessLevel[] | undefined;

    constructor(data?: IResponseOfListOfAccessLevelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AccessLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfAccessLevelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccessLevelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfAccessLevelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: AccessLevel[] | undefined;
}

export class ResponseOfListOfAccessLevel extends ResponseOfListOfAccessLevelAndString implements IResponseOfListOfAccessLevel {

    constructor(data?: IResponseOfListOfAccessLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfAccessLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfAccessLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfAccessLevel extends IResponseOfListOfAccessLevelAndString {
}

export class ListResponseOfAccessLevel extends ResponseOfListOfAccessLevel implements IListResponseOfAccessLevel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfAccessLevel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfAccessLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfAccessLevel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfAccessLevel extends IResponseOfListOfAccessLevel {
    totalRecords: number | undefined;
}

export class AccessLevel implements IAccessLevel {
    id!: string;
    skuId!: string;
    displayName!: string | undefined;
    sequence!: number;

    constructor(data?: IAccessLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.displayName = _data["displayName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): AccessLevel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["displayName"] = this.displayName;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IAccessLevel {
    id: string;
    skuId: string;
    displayName: string | undefined;
    sequence: number;
}

export class HtmlString implements IHtmlString {
    value!: string | undefined;

    constructor(data?: IHtmlString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HtmlString {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IHtmlString {
    value: string | undefined;
}

export class CourseDetailsRequest implements ICourseDetailsRequest {
    skuId!: string;
    timeZone!: string | undefined;
    isSeries!: boolean;

    constructor(data?: ICourseDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuId = _data["skuId"];
            this.timeZone = _data["timeZone"];
            this.isSeries = _data["isSeries"];
        }
    }

    static fromJS(data: any): CourseDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuId"] = this.skuId;
        data["timeZone"] = this.timeZone;
        data["isSeries"] = this.isSeries;
        return data;
    }
}

export interface ICourseDetailsRequest {
    skuId: string;
    timeZone: string | undefined;
    isSeries: boolean;
}

export class CreateFileJobRequest implements ICreateFileJobRequest {
    id!: string | undefined;
    importJobTypeId!: string;
    fileName!: string | undefined;

    constructor(data?: ICreateFileJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.importJobTypeId = _data["importJobTypeId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CreateFileJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["importJobTypeId"] = this.importJobTypeId;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICreateFileJobRequest {
    id: string | undefined;
    importJobTypeId: string;
    fileName: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export class FileDataRequest implements IFileDataRequest {
    data!: string[][] | undefined;
    columnMappings!: FileColumnMapping[] | undefined;
    rowIndex!: number;

    constructor(data?: IFileDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            if (Array.isArray(_data["columnMappings"])) {
                this.columnMappings = [] as any;
                for (let item of _data["columnMappings"])
                    this.columnMappings!.push(FileColumnMapping.fromJS(item));
            }
            this.rowIndex = _data["rowIndex"];
        }
    }

    static fromJS(data: any): FileDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.columnMappings)) {
            data["columnMappings"] = [];
            for (let item of this.columnMappings)
                data["columnMappings"].push(item ? item.toJSON() : undefined as any);
        }
        data["rowIndex"] = this.rowIndex;
        return data;
    }
}

export interface IFileDataRequest {
    data: string[][] | undefined;
    columnMappings: FileColumnMapping[] | undefined;
    rowIndex: number;
}

export class FileColumnMapping implements IFileColumnMapping {
    importJobTypeFieldId!: string;
    importJobTypeId!: string;
    dataType!: ImportDataType;
    columnName!: string | undefined;
    columnIndex!: number;
    required!: boolean;

    constructor(data?: IFileColumnMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importJobTypeFieldId = _data["importJobTypeFieldId"];
            this.importJobTypeId = _data["importJobTypeId"];
            this.dataType = _data["dataType"];
            this.columnName = _data["columnName"];
            this.columnIndex = _data["columnIndex"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): FileColumnMapping {
        data = typeof data === 'object' ? data : {};
        let result = new FileColumnMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importJobTypeFieldId"] = this.importJobTypeFieldId;
        data["importJobTypeId"] = this.importJobTypeId;
        data["dataType"] = this.dataType;
        data["columnName"] = this.columnName;
        data["columnIndex"] = this.columnIndex;
        data["required"] = this.required;
        return data;
    }
}

export interface IFileColumnMapping {
    importJobTypeFieldId: string;
    importJobTypeId: string;
    dataType: ImportDataType;
    columnName: string | undefined;
    columnIndex: number;
    required: boolean;
}

export enum ImportDataType {
    Guid = "Guid",
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Date = "Date",
    Boolean = "Boolean",
}

export class Menu implements IMenu {
    menuItems!: MenuItem[] | undefined;
    userInfo!: MenuUserInfo | undefined;

    constructor(data?: IMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItem.fromJS(item));
            }
            this.userInfo = _data["userInfo"] ? MenuUserInfo.fromJS(_data["userInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): Menu {
        data = typeof data === 'object' ? data : {};
        let result = new Menu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IMenu {
    menuItems: MenuItem[] | undefined;
    userInfo: MenuUserInfo | undefined;
}

export class MenuItem implements IMenuItem {
    name!: string;
    toolTip!: string | undefined;
    url!: string;
    icon!: string | undefined;
    id!: string;
    parentId!: string | undefined;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.url = _data["url"];
            this.icon = _data["icon"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["url"] = this.url;
        data["icon"] = this.icon;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IMenuItem {
    name: string;
    toolTip: string | undefined;
    url: string;
    icon: string | undefined;
    id: string;
    parentId: string | undefined;
}

export class MenuUserInfo implements IMenuUserInfo {
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    isImpersonation!: boolean;

    constructor(data?: IMenuUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isImpersonation = _data["isImpersonation"];
        }
    }

    static fromJS(data: any): MenuUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MenuUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isImpersonation"] = this.isImpersonation;
        return data;
    }
}

export interface IMenuUserInfo {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    isImpersonation: boolean;
}

export class SiteSettings implements ISiteSettings {
    theme!: SiteTheme | undefined;

    constructor(data?: ISiteSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] ? SiteTheme.fromJS(_data["theme"]) : undefined as any;
        }
    }

    static fromJS(data: any): SiteSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISiteSettings {
    theme: SiteTheme | undefined;
}

export class SiteTheme implements ISiteTheme {
    primaryColor!: ColorVariants | undefined;
    secondaryColor!: ColorVariants | undefined;
    tertiaryColor!: ColorVariants | undefined;
    backgroundColor!: ColorVariants | undefined;
    greenColor!: ColorVariants | undefined;
    redColor!: ColorVariants | undefined;
    grayColor!: ColorVariants | undefined;
    faviconUrl!: string | undefined;
    logoUrl!: string | undefined;
    logoAlternativeText!: string | undefined;
    externalHostUrl!: string | undefined;
    baseCssUrl!: string | undefined;

    constructor(data?: ISiteTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"] ? ColorVariants.fromJS(_data["primaryColor"]) : undefined as any;
            this.secondaryColor = _data["secondaryColor"] ? ColorVariants.fromJS(_data["secondaryColor"]) : undefined as any;
            this.tertiaryColor = _data["tertiaryColor"] ? ColorVariants.fromJS(_data["tertiaryColor"]) : undefined as any;
            this.backgroundColor = _data["backgroundColor"] ? ColorVariants.fromJS(_data["backgroundColor"]) : undefined as any;
            this.greenColor = _data["greenColor"] ? ColorVariants.fromJS(_data["greenColor"]) : undefined as any;
            this.redColor = _data["redColor"] ? ColorVariants.fromJS(_data["redColor"]) : undefined as any;
            this.grayColor = _data["grayColor"] ? ColorVariants.fromJS(_data["grayColor"]) : undefined as any;
            this.faviconUrl = _data["faviconUrl"];
            this.logoUrl = _data["logoUrl"];
            this.logoAlternativeText = _data["logoAlternativeText"];
            this.externalHostUrl = _data["externalHostUrl"];
            this.baseCssUrl = _data["baseCssUrl"];
        }
    }

    static fromJS(data: any): SiteTheme {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor ? this.primaryColor.toJSON() : undefined as any;
        data["secondaryColor"] = this.secondaryColor ? this.secondaryColor.toJSON() : undefined as any;
        data["tertiaryColor"] = this.tertiaryColor ? this.tertiaryColor.toJSON() : undefined as any;
        data["backgroundColor"] = this.backgroundColor ? this.backgroundColor.toJSON() : undefined as any;
        data["greenColor"] = this.greenColor ? this.greenColor.toJSON() : undefined as any;
        data["redColor"] = this.redColor ? this.redColor.toJSON() : undefined as any;
        data["grayColor"] = this.grayColor ? this.grayColor.toJSON() : undefined as any;
        data["faviconUrl"] = this.faviconUrl;
        data["logoUrl"] = this.logoUrl;
        data["logoAlternativeText"] = this.logoAlternativeText;
        data["externalHostUrl"] = this.externalHostUrl;
        data["baseCssUrl"] = this.baseCssUrl;
        return data;
    }
}

export interface ISiteTheme {
    primaryColor: ColorVariants | undefined;
    secondaryColor: ColorVariants | undefined;
    tertiaryColor: ColorVariants | undefined;
    backgroundColor: ColorVariants | undefined;
    greenColor: ColorVariants | undefined;
    redColor: ColorVariants | undefined;
    grayColor: ColorVariants | undefined;
    faviconUrl: string | undefined;
    logoUrl: string | undefined;
    logoAlternativeText: string | undefined;
    externalHostUrl: string | undefined;
    baseCssUrl: string | undefined;
}

export class ColorVariants implements IColorVariants {
    base!: string | undefined;
    light!: string | undefined;
    pale!: string | undefined;
    lighter!: string | undefined;
    lightPale!: string | undefined;
    ultraLight!: string | undefined;
    dark!: string | undefined;

    constructor(data?: IColorVariants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base = _data["base"];
            this.light = _data["light"];
            this.pale = _data["pale"];
            this.lighter = _data["lighter"];
            this.lightPale = _data["lightPale"];
            this.ultraLight = _data["ultraLight"];
            this.dark = _data["dark"];
        }
    }

    static fromJS(data: any): ColorVariants {
        data = typeof data === 'object' ? data : {};
        let result = new ColorVariants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base"] = this.base;
        data["light"] = this.light;
        data["pale"] = this.pale;
        data["lighter"] = this.lighter;
        data["lightPale"] = this.lightPale;
        data["ultraLight"] = this.ultraLight;
        data["dark"] = this.dark;
        return data;
    }
}

export interface IColorVariants {
    base: string | undefined;
    light: string | undefined;
    pale: string | undefined;
    lighter: string | undefined;
    lightPale: string | undefined;
    ultraLight: string | undefined;
    dark: string | undefined;
}

export class ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponseAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: AuthenticationResponse | undefined;

    constructor(data?: IResponseOfAuthenticationResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AuthenticationResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAuthenticationResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAuthenticationResponseAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: AuthenticationResponse | undefined;
}

export class ResponseOfAuthenticationResponse extends ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponse {

    constructor(data?: IResponseOfAuthenticationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAuthenticationResponse extends IResponseOfAuthenticationResponseAndString {
}

export class AuthenticationResponse implements IAuthenticationResponse {
    result!: boolean;
    id!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    organizationId!: string | undefined;
    returnUrl!: string | undefined;
    permissions!: string[] | undefined;
    impersonatedUserEmail!: string | undefined;
    impersonatingOrganizationUserId!: string | undefined;

    constructor(data?: IAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.returnUrl = _data["returnUrl"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.impersonatedUserEmail = _data["impersonatedUserEmail"];
            this.impersonatingOrganizationUserId = _data["impersonatingOrganizationUserId"];
        }
    }

    static fromJS(data: any): AuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["returnUrl"] = this.returnUrl;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["impersonatedUserEmail"] = this.impersonatedUserEmail;
        data["impersonatingOrganizationUserId"] = this.impersonatingOrganizationUserId;
        return data;
    }
}

export interface IAuthenticationResponse {
    result: boolean;
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    organizationId: string | undefined;
    returnUrl: string | undefined;
    permissions: string[] | undefined;
    impersonatedUserEmail: string | undefined;
    impersonatingOrganizationUserId: string | undefined;
}

export class ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrlAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: RedirectUrl | undefined;

    constructor(data?: IResponseOfRedirectUrlAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RedirectUrl.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRedirectUrlAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrlAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRedirectUrlAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: RedirectUrl | undefined;
}

export class ResponseOfRedirectUrl extends ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrl {

    constructor(data?: IResponseOfRedirectUrl) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrl();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRedirectUrl extends IResponseOfRedirectUrlAndString {
}

export class RedirectUrl implements IRedirectUrl {
    url!: string | undefined;

    constructor(data?: IRedirectUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): RedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IRedirectUrl {
    url: string | undefined;
}

export class ResponseOfBooleanAndString implements IResponseOfBooleanAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: boolean;

    constructor(data?: IResponseOfBooleanAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfBooleanAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBooleanAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfBooleanAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: boolean;
}

export class ResponseOfBoolean extends ResponseOfBooleanAndString implements IResponseOfBoolean {

    constructor(data?: IResponseOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfBoolean extends IResponseOfBooleanAndString {
}

export class AuthData implements IAuthData {
    applicationId!: string;
    organizationId!: string;
    userId!: string | undefined;
    isImpersonating!: boolean;
    stopImpersonationUrl!: string | undefined;

    constructor(data?: IAuthData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.isImpersonating = _data["isImpersonating"];
            this.stopImpersonationUrl = _data["stopImpersonationUrl"];
        }
    }

    static fromJS(data: any): AuthData {
        data = typeof data === 'object' ? data : {};
        let result = new AuthData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["isImpersonating"] = this.isImpersonating;
        data["stopImpersonationUrl"] = this.stopImpersonationUrl;
        return data;
    }
}

export interface IAuthData {
    applicationId: string;
    organizationId: string;
    userId: string | undefined;
    isImpersonating: boolean;
    stopImpersonationUrl: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}